import React from 'react'

interface BadgeProps {
  type?: string
  height?: number
  width?: number
}
const goToExpertAcademy = () => {
  window.open(
    'https://expertacademy.paro.io/collections/ab9397a4-0450-11ed-b358-02aea812ea2d',
    '_blank',
    'noopener'
  )
}

export const Badge = ({ type, height, width }: BadgeProps) => {
  return (
    <div onClick={goToExpertAcademy}>
      {type === 'Club' && (
        <svg
          width={width}
          height={height}
          viewBox='0 0 45 25'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M10.092 21.4097C9.16293 21.4097 8.40968 22.1622 8.40968 23.0912C8.40968 24.0203 9.16213 24.7736 10.0912 24.7736C11.0203 24.7736 11.7736 24.0211 11.7736 23.092V23.0912C11.7736 22.163 11.0203 21.4097 10.092 21.4097Z'
            fill='#A1E5E6'
          />
          <path
            d='M5.36121 24.7736C4.60633 24.7736 3.99463 24.1619 3.99463 23.407C3.99463 22.6521 4.60633 22.0404 5.36121 22.0404C6.11609 22.0404 6.72778 22.6521 6.72778 23.407C6.72778 24.1619 6.11609 24.7736 5.36121 24.7736Z'
            fill='#A1E5E6'
          />
          <path
            d='M10.407 19.7278C9.6521 19.7278 9.04041 19.1161 9.04041 18.3612C9.04041 17.6063 9.6521 16.9946 10.407 16.9946C11.1619 16.9946 11.7736 17.6063 11.7736 18.3612C11.7736 19.1161 11.1619 19.7278 10.407 19.7278Z'
            fill='#A1E5E6'
          />
          <path
            d='M2.31268 23.6172C2.31268 24.2562 1.7945 24.7736 1.15635 24.7736C0.517366 24.7736 1.48762e-05 24.2554 1.48762e-05 23.6172C1.48762e-05 22.9783 0.518199 22.4609 1.15635 22.4609C1.7945 22.4609 2.31268 22.9783 2.31268 23.6172Z'
            fill='#A1E5E6'
          />
          <path
            d='M11.7736 14.1563C11.7736 14.7953 11.2554 15.3127 10.6172 15.3127C9.97824 15.3127 9.46089 14.7945 9.46089 14.1563C9.46089 13.5173 9.97908 13 10.6172 13C11.2554 13 11.7736 13.5173 11.7736 14.1563Z'
            fill='#A1E5E6'
          />
          <path
            d='M7.56873 19.6226C7.56873 20.2616 7.05054 20.779 6.41239 20.779C5.77341 20.779 5.25606 20.2608 5.25606 19.6226C5.25606 18.9837 5.77424 18.4663 6.41239 18.4663C7.05054 18.4663 7.56873 18.9837 7.56873 19.6226Z'
            fill='#A1E5E6'
          />
          <path
            d='M13.2453 5.8868C13.2453 2.63561 15.8809 0 19.1321 0H41.8491C43.4747 0 44.7925 1.3178 44.7925 2.9434V21.8302C44.7925 23.4558 43.4747 24.7736 41.8491 24.7736H16.1887C14.5631 24.7736 13.2453 23.4558 13.2453 21.8302V5.8868Z'
            fill='#A1E5E6'
          />
          <path
            d='M29.5826 15.9898C29.0331 15.9898 28.5215 15.9005 28.0476 15.722C27.5806 15.5365 27.1719 15.279 26.8217 14.9493C26.4783 14.6128 26.2104 14.2179 26.0181 13.7646C25.8258 13.3113 25.7297 12.8168 25.7297 12.2811C25.7297 11.7454 25.8258 11.2509 26.0181 10.7977C26.2104 10.3444 26.4817 9.9529 26.832 9.62324C27.1822 9.28672 27.5909 9.02917 28.0579 8.8506C28.5249 8.66517 29.0366 8.57245 29.5929 8.57245C30.1835 8.57245 30.7226 8.67547 31.2103 8.88151C31.6979 9.08068 32.11 9.37943 32.4465 9.77777L31.5811 10.5916C31.3202 10.31 31.0283 10.1006 30.7055 9.96321C30.3827 9.81898 30.0324 9.74687 29.6547 9.74687C29.2769 9.74687 28.9301 9.80868 28.6142 9.9323C28.3051 10.0559 28.0338 10.2311 27.8003 10.4577C27.5737 10.6843 27.3951 10.9522 27.2646 11.2612C27.141 11.5703 27.0792 11.9103 27.0792 12.2811C27.0792 12.652 27.141 12.992 27.2646 13.301C27.3951 13.6101 27.5737 13.8779 27.8003 14.1046C28.0338 14.3312 28.3051 14.5063 28.6142 14.63C28.9301 14.7536 29.2769 14.8154 29.6547 14.8154C30.0324 14.8154 30.3827 14.7467 30.7055 14.6094C31.0283 14.4651 31.3202 14.2488 31.5811 13.9603L32.4465 14.7845C32.11 15.176 31.6979 15.4747 31.2103 15.6808C30.7226 15.8868 30.1801 15.9898 29.5826 15.9898Z'
            fill='#060821'
          />
        </svg>
      )}
      {type === 'Elite' && (
        <svg
          width={width}
          height={height}
          viewBox='0 0 46 25'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M10.2553 21.5457C9.31114 21.5457 8.54571 22.3103 8.54571 23.2544C8.54571 24.1985 9.31034 24.964 10.2544 24.964C11.1986 24.964 11.964 24.1993 11.964 23.2552V23.2544C11.964 22.3111 11.1986 21.5457 10.2553 21.5457Z'
            fill='#248384'
          />
          <path
            d='M5.44787 24.964C4.68079 24.964 4.0592 24.3424 4.0592 23.5753C4.0592 22.8082 4.68079 22.1866 5.44787 22.1866C6.21496 22.1866 6.83655 22.8082 6.83655 23.5753C6.83655 24.3424 6.21496 24.964 5.44787 24.964Z'
            fill='#248384'
          />
          <path
            d='M10.5753 19.8365C9.80823 19.8365 9.18664 19.215 9.18664 18.4479C9.18664 17.6808 9.80823 17.0592 10.5753 17.0592C11.3424 17.0592 11.964 17.6808 11.964 18.4479C11.964 19.215 11.3424 19.8365 10.5753 19.8365Z'
            fill='#248384'
          />
          <path
            d='M2.3501 23.7889C2.3501 24.4382 1.82353 24.964 1.17507 24.964C0.52575 24.964 3.34424e-05 24.4374 3.34424e-05 23.7889C3.34424e-05 23.1396 0.526597 22.6139 1.17507 22.6139C1.82353 22.6139 2.3501 23.1396 2.3501 23.7889Z'
            fill='#248384'
          />
          <path
            d='M11.964 14.175C11.964 14.8243 11.4374 15.3501 10.789 15.3501C10.1396 15.3501 9.61393 14.8235 9.61393 14.175C9.61393 13.5257 10.1405 13 10.789 13C11.4374 13 11.964 13.5257 11.964 14.175Z'
            fill='#248384'
          />
          <path
            d='M7.6911 19.7297C7.6911 20.379 7.16454 20.9048 6.51607 20.9048C5.86675 20.9048 5.34104 20.3782 5.34104 19.7297C5.34104 19.0804 5.8676 18.5547 6.51607 18.5547C7.16454 18.5547 7.6911 19.0804 7.6911 19.7297Z'
            fill='#248384'
          />
          <path
            d='M13.4595 5.98198C13.4595 2.67822 16.1377 0 19.4415 0H45.3874V21.973C45.3874 23.6249 44.0483 24.964 42.3964 24.964H13.4595V5.98198Z'
            fill='#248384'
          />
          <path
            d='M28.1572 11.7004H31.8002V12.8205H28.1572V11.7004ZM28.2619 14.8409H32.3969V15.982H26.901V8.65405H32.2504V9.79511H28.2619V14.8409Z'
            fill='white'
          />
        </svg>
      )}
      {type === 'Beyond' && (
        <svg
          width={width}
          height={height}
          viewBox='0 0 46 25'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M10.2489 21.5404C9.30539 21.5404 8.54043 22.3046 8.54043 23.2481C8.54043 24.1917 9.30458 24.9566 10.2481 24.9566C11.1916 24.9566 11.9566 24.1925 11.9566 23.2489V23.2481C11.9566 22.3054 11.1916 21.5404 10.2489 21.5404Z'
            fill='#FB9A1D'
          />
          <path
            d='M5.44458 24.9566C4.67796 24.9566 4.05675 24.3354 4.05675 23.5688C4.05675 22.8022 4.67796 22.181 5.44458 22.181C6.21119 22.181 6.8324 22.8022 6.8324 23.5688C6.8324 24.3354 6.21119 24.9566 5.44458 24.9566Z'
            fill='#FB9A1D'
          />
          <path
            d='M10.5688 19.8324C9.80217 19.8324 9.18096 19.2111 9.18096 18.4445C9.18096 17.6779 9.80217 17.0567 10.5688 17.0567C11.3354 17.0567 11.9566 17.6779 11.9566 18.4445C11.9566 19.2111 11.3354 19.8324 10.5688 19.8324Z'
            fill='#FB9A1D'
          />
          <path
            d='M2.34863 23.7823C2.34863 24.4312 1.82239 24.9566 1.17432 24.9566C0.525406 24.9566 1.16389e-05 24.4304 1.16389e-05 23.7823C1.16389e-05 23.1334 0.526252 22.608 1.17432 22.608C1.82239 22.608 2.34863 23.1334 2.34863 23.7823Z'
            fill='#FB9A1D'
          />
          <path
            d='M11.9566 14.1743C11.9566 14.8232 11.4304 15.3486 10.7823 15.3486C10.1334 15.3486 9.60798 14.8224 9.60798 14.1743C9.60798 13.5254 10.1342 13 10.7823 13C11.4304 13 11.9566 13.5254 11.9566 14.1743Z'
            fill='#FB9A1D'
          />
          <path
            d='M7.6864 19.7256C7.6864 20.3745 7.16016 20.8999 6.51209 20.8999C5.86317 20.8999 5.33778 20.3737 5.33778 19.7256C5.33778 19.0767 5.86402 18.5513 6.51209 18.5513C7.16016 18.5513 7.6864 19.0767 7.6864 19.7256Z'
            fill='#FB9A1D'
          />
          <path
            d='M13.4512 5.97831C13.4512 2.67658 16.1278 0 19.4295 0H42.3752C44.0261 0 45.3644 1.33829 45.3644 2.98915V21.9675C45.3644 23.6183 44.0261 24.9566 42.3753 24.9566H16.4403C14.7895 24.9566 13.4512 23.6183 13.4512 21.9675V5.97831Z'
            fill='#FB9A1D'
          />
          <path
            d='M26.4118 15.9783V8.65487H29.8433C30.7221 8.65487 31.3917 8.82924 31.852 9.17798C32.3123 9.51974 32.5425 9.98007 32.5425 10.559C32.5425 10.9495 32.4518 11.2843 32.2705 11.5633C32.0892 11.8353 31.845 12.0481 31.5382 12.2015C31.2382 12.348 30.9104 12.4212 30.5547 12.4212L30.743 12.0446C31.1545 12.0446 31.5242 12.1213 31.852 12.2747C32.1798 12.4212 32.4379 12.6374 32.6262 12.9234C32.8215 13.2093 32.9191 13.5651 32.9191 13.9905C32.9191 14.6182 32.6785 15.1065 32.1973 15.4552C31.716 15.8039 31.0011 15.9783 30.0525 15.9783H26.4118ZM27.7718 14.9112H29.9688C30.478 14.9112 30.8686 14.8275 31.1406 14.6601C31.4126 14.4927 31.5486 14.2242 31.5486 13.8545C31.5486 13.4918 31.4126 13.2268 31.1406 13.0594C30.8686 12.885 30.478 12.7978 29.9688 12.7978H27.6672V11.7412H29.6968C30.1711 11.7412 30.5338 11.6575 30.7849 11.4901C31.0429 11.3227 31.172 11.0716 31.172 10.7368C31.172 10.3951 31.0429 10.1405 30.7849 9.97309C30.5338 9.8057 30.1711 9.722 29.6968 9.722H27.7718V14.9112Z'
            fill='#060821'
          />
        </svg>
      )}
    </div>
  )
}
